import { getKey } from '../../translate/dictionary';
import II18 from '../../translate/II18';
import { gae } from '../../helpers/Analytics';

const isFirefoxBrowser = () => /Firefox|FxiOS/i.test(navigator.userAgent || '');
const isIOSDevice = () => /iPad|iPhone|iPod/i.test(navigator.userAgent || '');
const isEdgeBrowser = () => /Edg\//i.test(navigator.userAgent || '');

/** Raw dictionary string (II18.get returns a React node when text contains <b>). */
const t = key => getKey(key, window.userLang);

/** Browser-specific steps to allow pop-ups for this site. */
export const getPopupBlockedHelpMessage = () => {
  if (window.isSafari && isIOSDevice()) {
    return t('popup_blocked_help_safari_ios');
  }
  if (window.isSafari) {
    return t('popup_blocked_help_safari');
  }
  if (isFirefoxBrowser()) {
    return t('popup_blocked_help_firefox');
  }
  if (isEdgeBrowser()) {
    return t('popup_blocked_help_edge');
  }
  if (window.isChrome) {
    return t('popup_blocked_help_chrome');
  }
  return t('popup_blocked_help_generic');
};

/**
 * Dialog explaining how to enable pop-ups in the current browser.
 * @param {object} f7 - Framework7 app instance
 */
export const showPopupBlockedHelpDialog = f7 => {
  gae('QES_POPUP', 'BLOCKED_HELP_SHOWN');

  f7.dialog
    .create({
      title: II18.get('signme_settings_nopopup_title'),
      content: `<div style="text-align:left;padding:4px 2px;line-height:1.4">${getPopupBlockedHelpMessage()}</div>`,
      buttons: [
        {
          text: II18.get('title_close')
        }
      ]
    })
    .open();
};
